// Dropdown options (product families + resellers). Uses useApiData so the values
// come from the browser cache instantly when they were prefetched on login,
// meaning the dropdowns are populated the moment the page renders.
import { useApiData } from './useApiData';

export function useOptions() {
  const { data, loading, error } = useApiData('/api/data/options');
  return {
    productFamilies: data?.productFamilies || [],
    products: data?.products || [],
    resellers: data?.resellers || [],
    dateRange: data?.dateRange || null,
    loading,
    error,
  };
}
